import React from "react";

// 3D hardcover mock: angled so the page block shows; flips to reveal the back cover.
export const CognitoBook = ({ front, back, flipped, onBackClick }) => (
  <div className="book3d-stage absolute inset-0 flex items-center justify-center" data-testid="cognito-book-3d">
    <div className={`book3d ${flipped ? "is-flipped" : ""}`} data-testid="cognito-flip-inner">
      <img src={front} alt="AiPresidential: COGNITO front cover" className="book3d-face book3d-front" data-testid="cognito-front-cover" />
      <div className="book3d-pages" aria-hidden="true" />
      <div className="book3d-spine" aria-hidden="true" />
      <button type="button" onClick={onBackClick} className="book3d-face book3d-back cursor-zoom-in" aria-label="Enlarge back cover" data-testid="cognito-back-cover">
        <img src={back} alt="AiPresidential: COGNITO back cover" className="w-full h-full object-cover" />
      </button>
    </div>
  </div>
);
